module.exports = __webpack_public_path__ + "assets/svg/Icons/32/no-show-gray-a92052.svg";